export default function PercentIcon({
  size = 'w-[24px] h-[24px]',
  color = 'white',
}) {
  return (
    <svg
      className={size}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 5.75L5.25 19.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 10.25C8.57475 10.25 9.75 9.07475 9.75 7.625C9.75 6.17525 8.57475 5 7.125 5C5.67525 5 4.5 6.17525 4.5 7.625C4.5 9.07475 5.67525 10.25 7.125 10.25Z"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M16.875 20C18.3247 20 19.5 18.8247 19.5 17.375C19.5 15.9253 18.3247 14.75 16.875 14.75C15.4253 14.75 14.25 15.9253 14.25 17.375C14.25 18.8247 15.4253 20 16.875 20Z"
        stroke={color}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
